import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { MemberService } from './../../../../../rest/api/member.service';
import { AuthService } from './../../../../../services/auth.service';

@Component({
  selector: 'app-delete-hotspots-modal',
  templateUrl: './delete-hotspots-modal.component.html',
  styleUrls: ['./delete-hotspots-modal.component.scss']
})
export class DeleteHotspotsModalComponent implements OnInit, OnChanges {
  @Input() editHotspots;
  @Input() hotspotType;
  @Output() modalCloseEmit = new EventEmitter();
  isSubmitted = false;
  accessToken: any;
  deleteError;
  deleteSuccess;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editHotspots && changes.editHotspots.currentValue) {
      this.resetErrorValues();
    }
    // if (changes.deleteSuccess && changes.deleteSuccess.currentValue) {
    //   this.isSubmitted = false;
    //   setTimeout(() => {
    //     this.modalCloseEmit.emit(true);
    //   }, 2000);
    // }
  }

  deleteHotspots(editHotspots) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteHotspotsEmit(editHotspots);
  }

  deleteHotspotsEmit(editHotspots) {
    this.deleteError = undefined;

    if (this.hotspotType === 'link') {
      this.memberService.deleteHotspot({
        Authorization: this.accessToken,
        id: editHotspots.uuid
      }).subscribe((response: any) => {
        this.deleteSuccess = 'Hotspot was successfully deleted.';
        setTimeout(() => {
          this.modalCloseEmit.emit(editHotspots);
        }, 2000);
      }, err => {
        if (err.error && err.error.error) {
          this.deleteError = err.error.error;
        } else {
          this.deleteError = 'There was error while deleting hotspot.';
        }
      });
    } else if (this.hotspotType === 'info') {
      this.memberService.deleteInfoHotspot({
        Authorization: this.accessToken,
        id: editHotspots.uuid
      }).subscribe((response: any) => {
        this.deleteSuccess = 'Info hotspot was successfully deleted.';
        setTimeout(() => {
          this.modalCloseEmit.emit(editHotspots);
        }, 2000);
      }, err => {
        if (err.error && err.error.error) {
          this.deleteError = err.error.error;
        } else {
          this.deleteError = 'There was error while deleting hotspot.';
        }
      });
    }

  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

}
